import { render, staticRenderFns } from "./EmailFormat.vue?vue&type=template&id=c41a038c&scoped=true&lang=pug"
import script from "./EmailFormat.vue?vue&type=script&lang=js"
export * from "./EmailFormat.vue?vue&type=script&lang=js"
import style0 from "./EmailFormat.vue?vue&type=style&index=0&id=c41a038c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41a038c",
  null
  
)

export default component.exports